<template>
  <div class="button-frame">
    <i
      class="camera icon icon-camera-classic"
      @click="openPopUp"
    />
    <div v-show="visibility">
      <div class="overlay" @click.self="closePopUp"></div>
      <div class="pop-up">
        <div v-show="!isOffline && !!video.targetId" :id="video.targetId" style="width:1200px; height:675px;">&nbsp;</div> <!-- Kaltura -->
        <video-player v-if="isOffline || !isOffline && !video.targetId && videoPath != ''"
          ref="VideoPlayer"
          :videoUrl="getVideoUrl()"
          @videoStarted="$emit('videoStarted')"
          @videoPlayed="$emit('videoPlayed')"
          @videoFinished="$emit('videoFinished')"
          @videoPaused="$emit('videoPaused')"
          @soundUnmuted="$emit('soundUnmuted')"
          @soundMuted="$emit('soundMuted')"
          @videoLoaded="$emit('videoLoaded')"
          @videoSeeked="$emit('videoSeeked')"
        ></video-player> <!-- Regular Video -->
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from './VideoPlayerComponent';
import * as KalturaPlayer from 'kaltura-player-js/dist/kaltura-ovp-player';
import AssetsApiService from '@/services/assetsServices/assetsApiService';

export default {
  name: 'PopUp',
  components: {
    'video-player': VideoPlayer,
  },
  props: {
    video: {
			type: Object,
			default: null
		},
    videoUrl: {
      type: String,
      default: null,
    },
    isOffline: {
      type: Boolean,
      default: null,
    }
  },
  data() {
    return { visibility: false, videoPath: '' };
  },
  async mounted() {
    if (!this.isOffline) {
      this.videoPath = await AssetsApiService.getVideoUrl(this.video.fileName);
    }
  },
  methods: {
    openPopUp() {
      this.visibility = true;

      if (!this.isOffline) {
        this.setupKalturaPlayer();
      }
    },
    closePopUp() {
      if (!this.isOffline && !!this.video.targetId) {
        kWidget.destroy( this.video.targetId );
      } else {
        this.$refs.VideoPlayer.stopVideo();
      }
      this.visibility = false;
    },
    setupKalturaPlayer() {
      kWidget.embed({
        targetId: this.video.targetId,
        wid: this.video.wid,
        uiconf_id: this.video.uiconfId,
        flashvars: {
          streamerType: "auto"
        },
        cache_st: this.video.cacheSt,
        entry_id: this.video.entryId
      });
    },
    getVideoUrl() {
      if (this.isOffline) {
        const isProdElectron = process.env.IS_ELECTRON && process.env.NODE_ENV === 'production';
        return isProdElectron ? `file://${this.videoUrl}` : this.videoUrl;
      }

      return this.videoPath.toString();
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100vw;
  background-color: black;
  opacity: 0.5;
}
.pop-up {
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: black;
}
.camera {
  margin: 8px;
  top: -5px;
  position: relative;
  cursor: pointer;
}
.button-frame {
   user-select: none;
}
</style>
